import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextIndentLeft"><Path d="M9.5 6.5H21.5M21.5 12H9.5M9.5 17.5H21.5M2.5 9.5V14.5L6 12L2.5 9.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextIndentLeft;
